import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  canAccessBusiness,
  resolveAccessContext,
} from "../access/capabilities";

function usePermissions() {
  const authState = useSelector((state) => state?.auth || {});
  const context = useMemo(() => resolveAccessContext(authState), [authState]);
  const checkBusinessAccess = useCallback(
    (businessId) => canAccessBusiness(context, businessId),
    [context]
  );

  return useMemo(
    () => ({
      ...context,
      canAccessBusiness: checkBusinessAccess,
    }),
    [checkBusinessAccess, context]
  );
}

export default usePermissions;
